import { jwtDecode } from "jwt-decode";
import { create } from "zustand";

interface AuthStore {
  token: string | undefined;
  setToken: (token: string) => void;
  userNm: string | undefined;
  role: string | undefined;
  deviceId: string | null;
  setDeviceId: (id: string | null) => void;
  message: string | undefined;
  setMessage: (msg: string | undefined) => void;
  timezone: string | undefined;
  appVersion: string | undefined;
  codepushVersion: string | undefined;
  osType: string | undefined;
  setTimezone: (timezone: string | undefined) => void;
  setAppVersion: (appVersion: string | undefined) => void;
  setCodepushVersion: (codepushVersion: string | undefined) => void;
  setOsType: (osType: string | undefined) => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  token: undefined,
  userNm: undefined,
  role: undefined,
  deviceId: null,
  timezone: undefined,
  appVersion: undefined,
  codepushVersion: undefined,
  osType: undefined,
  message: undefined,
  setToken: (token) => {
    if (token) {
      try {
        const jwtToken: any = jwtDecode(token);
        set({
          token,
          userNm: jwtToken.userNm || undefined,
          role: jwtToken.auth[0].authority,
        });
      } catch (e) {
        console.error("token decoding fail", e);
        set({
          token,
          userNm: undefined,
          role: undefined,
        });
      }
    }
  },
  setDeviceId: (id) => {
    if (id) {
      set({
        deviceId: id,
      });
    }
  },
  setTimezone: (time) => {
    if (time) {
      set({
        timezone: time,
      });
    }
  },
  setAppVersion: (version) => {
    if (version) {
      set({
        appVersion: version,
      });
    }
  },
  setCodepushVersion: (version) => {
    if (version) {
      set({
        codepushVersion: version,
      });
    }
  },
  setOsType: (type) => {
    if (type) {
      set({
        osType: type,
      });
    }
  },
  setMessage: (msg) => {
    set({
      message: msg,
    });
  },
}));
